/* eslint-disable @typescript-eslint/camelcase */
import * as Constant from "@/constant";
import { Network } from "@/network";
import { Log } from "@/util";

// ------------------------- type -------------------------

type QuestionForm = {
  id: string;
  name: string;
  selected: boolean;
  answer: string;
};

type Question = {
  [key: string]: QuestionForm;
};

export type Contact = {
  id: string;
  imgSrc: string;
  title: string;
  itemNo: string;
  description: string;
  finish: string;
  width: string;
  question: Question;
  otherQuestion: string;
  isPoint: string;
};

export type Request = {
  description: string;
  finish: string;
  is_point: string;
  item_no: string;
  maid: string;
  name: string;
  others: string;
  pic: string;
  record: {
    [key: string]: {
      a: string;
      q: string;
      qid: string;
    };
  };
  width: string;
};

// ------------------------- class -------------------------

class ContactModel {
  private static sInstance: ContactModel;

  public static get instance(): ContactModel {
    if (!ContactModel.sInstance) {
      ContactModel.sInstance = new ContactModel();
    }

    return ContactModel.sInstance;
  }

  private userInfo: { name: string; sales: string; point: string } = {
    name: "",
    sales: "",
    point: ""
  };
  private contactList: Contact[] = [];

  public async switch(item: object): Promise<number> {
    let errNo = Constant.ErrorCode.NotResponse;

    await Network.sendAPI("/contact/switchRequest", "post", item)
      .then(response => {
        const data = response.data as { [key: string]: unknown };
        errNo = data.ERR_CODE as number;
      })
      .catch(error => {
        Log.error(error);
      });

    return errNo;
  }

  public async getUserData(): Promise<void> {
    await Network.sendAPI("/contact/getContactInfo", "post")
      .then(response => {
        const rawData = response.data as { [key: string]: unknown };
        this.convertUserData(rawData);
      })
      .catch(error => {
        Log.error(error);
      });
  }

  public async alreadyShowHintToUser(): Promise<number> {
    let errNo = Constant.ErrorCode.NotResponse;

    await Network.sendAPI("/contact/cancelPoint", "post")
      .then(response => {
        const data = response.data as { [key: string]: unknown };
        errNo = data.ERR_CODE as number;
      })
      .catch(error => {
        Log.error(error);
      });

    return errNo;
  }

  public async save(item: object): Promise<number> {
    let errNo = Constant.ErrorCode.NotResponse;

    await Network.sendAPI("/contact/saveContact", "post", item)
      .then(response => {
        const data = response.data as { [key: string]: unknown };
        errNo = data.ERR_CODE as number;
      })
      .catch(error => {
        Log.error(error);
      });

    return errNo;
  }

  public async submit(item: object): Promise<number> {
    let errNo = Constant.ErrorCode.NotResponse;

    await Network.sendAPI("/contact/sendContact", "post", item)
      .then(response => {
        const data = response.data as { [key: string]: unknown };
        errNo = data.ERR_CODE as number;
      })
      .catch(error => {
        Log.error(error);
      });

    return errNo;
  }

  private convertUserData(rawData: { [key: string]: unknown }): void {
    const userData = rawData as {
      memberName: string;
      point: string;
      requestList: Request[];
      salesName: string;
    };

    this.userInfo.name = userData.memberName;
    this.userInfo.sales = userData.salesName;
    this.userInfo.point = userData.point;

    this.contactList = [];
    userData.requestList.forEach(request => {
      const item = {
        id: request.maid,
        imgSrc: request.pic,
        title: request.name,
        itemNo: request.item_no,
        description: request.description,
        finish: request.finish,
        width: request.width,
        question: {} as Question,
        otherQuestion: request.others,
        isPoint: request.is_point
      };
      Object.keys(request.record).forEach(key => {
        const questionItem = {
          id: request.record[key].qid,
          name: request.record[key].q,
          answer: request.record[key].a,
          selected: request.record[key].a !== ""
        };
        item.question[key] = questionItem;
      });
      this.contactList.push(item);
    });
  }

  public convertRequestList(contactList: Contact[]): Request[] {
    const requestList: Request[] = [];

    contactList.forEach(contact => {
      const item: Request = {
        description: contact.description,
        finish: contact.finish,
        is_point: contact.isPoint,
        pic: contact.imgSrc,
        item_no: contact.itemNo,
        maid: contact.id,
        name: contact.title,
        others: contact.otherQuestion,
        record: {},
        width: contact.width
      };
      Object.keys(contact.question).forEach(key => {
        const questionItem = {
          q: contact.question[key].name,
          a: contact.question[key].answer,
          qid: contact.question[key].id
        };
        item.record[key] = questionItem;
      });
      requestList.push(item);
    });

    return requestList;
  }

  public getUserInfo(): { name: string; sales: string } {
    return this.userInfo;
  }

  public getContactList(): Contact[] {
    return this.contactList;
  }
}

const contactModel = ContactModel.instance;

export { contactModel as ContactModel };
